export default __webpack_public_path__ + "static/media/ImgB3.4d109ff9.png";